import { CategoryWithArtistsType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { ArtistRosterTableRow } from './components';

type ArtistRosterTablePropsType = {
  categoriesWithArtists: CategoryWithArtistsType[];
};

export const ArtistRosterTable: React.FC<ArtistRosterTablePropsType> = ({
  categoriesWithArtists,
}) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {categoriesWithArtists.map((categoryWithArtists) => (
          <ArtistRosterTableRow
            key={categoryWithArtists.category}
            categoryWithArtists={categoryWithArtists}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};
